/**************************************************
 * Nombre:       Casilla_Titulo_Dinero
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, TableCell, Typography} from "@mui/material";
import {COLORTEXTO} from "../../../Constantes";
import {formatoFechaTabla} from "../../../Utilidades/formatoFechaTabla";
import {formatoMonedaTabla} from "../../../Utilidades/formatoMonedaTabla";

const Casilla_Titulo_Dinero = ({titulo, dato, dir, decimales = 0}) => {

    return (
        <TableCell key={dato} variant={'body'} align={dir}
                   sx={{color: COLORTEXTO, fontWeight: 600, fontSize: 14, minWidth: 160}}>
            <Grid container size={12} alignItems={'center'}>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography sx={{fontSize: 12}}>
                            {titulo ? titulo: ''}
                        </Typography>
                    </Grid>
                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography sx={{fontSize: 14, fontWeight: 600}}>
                            {formatoMonedaTabla(dato, decimales)}
                        </Typography>
                    </Grid>
                </Grid>

            </Grid>

        </TableCell>

    )

}
export default Casilla_Titulo_Dinero